import *as React from 'react'

import {Horaires} from '../Dashboard/Horaires'
import {ExpHours} from '../Dashboard/ExpHours'
import {Closing} from '../Dashboard/Closing'

import "./time.scss"

export  function TimeBoard() {

    const [page, setPage] = React.useState(0)

    return (
        <div className="template-h">
            <h1>Gestion des Horaires</h1>
            {/* <div className="buttons">
                <button className={page==0?"selected":""} onClick={()=>{setPage(0)}}>Horaires</button>
                <button className={page==1?"selected":""} onClick={()=>{setPage(1)}}>Horaires exeptionels</button>
            </div> */}
            <div className="Horaires">
            {/* {(page==0)?<div>horaire</div>:<ExpHours />} */}
            {(page==0)?<Horaires />:<ExpHours/>}
            {/* <Closing /> */}
            </div>
            
        </div>
    )
}
